// Whether a task shows the scheduler, or a way in to it.
//
// The scheduler appeared only on tasks the AI had read as appointment
// requests. When it missed one, the office had no way in short of the
// Category dropdown at the bottom of the panel. Any task can be scheduled
// from: the AI's read is a default, not a gate.
export type SchedulingEntry = 'panel' | 'offer';

export function schedulingEntry(task: {
  category?: string | null;
  hasSchedulingState: boolean;
  /** The office pressed "Schedule an appointment" on this task in this session. */
  openedByStaff?: boolean;
}): SchedulingEntry {
  return task.openedByStaff || task.hasSchedulingState || task.category === 'appointment' ? 'panel' : 'offer';
}
